export enum DetailsView {
	MATCHING = 'matching',
	CANDIDATES = 'candidates',
	RECRUITMENT = 'recruitment',
	POOL = 'pool',
	MISSIONS = 'missions',
	REJECTED_PROFILES = 'rejectedProfiles',
}
